import script from "./MembersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MembersView.vue?vue&type=script&lang=ts&setup=true"

import "./MembersView.vue?vue&type=style&index=0&id=1aa533df&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa533df"]])

export default __exports__